export const getImageType = (imageSource: string): string => {
    const extensionMatch = imageSource.match(/\.(\w+)(\?.*)?$/);

    if (extensionMatch) {
        return `image/${extensionMatch[1].toLowerCase()}`;
    }

    return '';
};
